import styles from '../MultiStepPMSLogin.module.scss'
import ohip from '../ohip.png'
import oracle from '../oracle.png'

const PMSLoginSuccess = ({ hubId, propertyId }) => {
  return (
    <div className={styles.card}>
      <div className={styles.pmsSuccessContainer}>
        <div className={styles.logo}>
          <img className={styles.logoLeft} src={oracle} alt={'oracle'} />
          <img className={styles.logoRight} src={ohip} alt={'ohip'} />
        </div>
        <p className={styles.cardDescription}>
          {`Hotel is connected to OHIP with hub id: ${hubId} and property id: ${propertyId}`}
        </p>
      </div>
    </div>
  )
}

export default PMSLoginSuccess
